import { NavLink } from "react-router-dom";
import { Newspaper, Search, Bookmark, Radio } from "lucide-react";
import { useSaved } from "@/hooks/useSaved";

const tabs = [
  { to: "/", label: "Início", icon: Newspaper, id: "home" },
  { to: "/pesquisa", label: "Pesquisar", icon: Search, id: "search" },
  { to: "/guardados", label: "Guardados", icon: Bookmark, id: "saved" },
  { to: "/fontes", label: "Fontes", icon: Radio, id: "sources" },
];

export function BottomNav() {
  const { saved } = useSaved();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/90 backdrop-blur-xl pb-safe lg:hidden">
      <div className="grid h-16 grid-cols-4">
        {tabs.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={to} to={to} end data-testid={`bottom-nav-${id}`}
            className={({ isActive }) => `relative flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`}>
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute top-0 h-[3px] w-10 rounded-b-full bg-primary" />}
                <span className="relative">
                  <Icon size={21} strokeWidth={isActive ? 2.5 : 2} />
                  {id === "saved" && saved.length > 0 && (
                    <span data-testid="saved-count-badge" className="absolute -right-2 -top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-primary px-1 text-[9px] text-white">{saved.length}</span>
                  )}
                </span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
